import axios from '@/bootstrap'
const endpoint = 'weeks-of-year'

export default class WeeksOfYearService {
  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }
}
